import React, { Component } from 'react';
import PropTypes from 'prop-types';
import tinycolor from 'tinycolor2';
import {
  ProgressBar, FormGroup, ControlLabel,
  Dropdown, MenuItem,
} from 'react-bootstrap';
import {
  indexOf, find, first, slice,
  truncate, each,
} from 'lodash';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';

import {
  getUser, getUserCurrentOrganization,
} from '../../modules/Auth/AuthReducer';
import NumberDisplay from '../number-display';
import {
  getTeamTree, getTeamTreeOwners,
  getTeamTreeLoading, getTeamTreeLoaded,
} from '../../modules/Team/TeamReducer';
import TeamMemberNode from './team-member-node';
import { COLORS } from './master-field';

import { fetchTeamTree } from '../../modules/Team/TeamActions';

import styles from './styles.css';

const ALL_SALES_REPS = { name: 'All Sales Reps', _id: null };

class TeamSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
    this.showMore = this.showMore.bind(this);
  }

  componentDidMount() {
    this.checkTeamLoad(this.props);
    if (this.props.loaded) {
      this.selectFirstTeam(this.props.selectedTeam, this.props.teams);
    } else if (!this.props.canSeeTeamSeletor) {
      this.selectFirstTeam(null, []);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.canSeeTeamSeletor && !this.props.canSeeTeamSeletor) {
      this.checkTeamLoad(nextProps);
    }
    if (!this.props.loaded && nextProps.loaded) {
      this.selectFirstTeam(nextProps.selectedTeam, nextProps.teams);
    }
  }

  setTeam(team) {
    this.props.onTeamChange(team);
  }

  selectFirstTeam(preferTeam, teams) {
    let team = null;
    if (preferTeam) {
      if (preferTeam._id) {
        team = find(teams, { _id: preferTeam._id });
      } else if (preferTeam.is_default !== undefined) {
        team = find(teams, { is_default: preferTeam.is_default }) || first(teams);
        
      }
    }
    this.props.onTeamChange(team, true);
  }

  showMore(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showMore: !this.state.showMore });
  }

  checkTeamLoad(props) {
    if (!props.loaded && !props.loading && props.canSeeTeamSeletor) {
      this.props.dispatch(fetchTeamTree());
    }
  }

  renderLoading() {
    return (
      <div className="container">
        <ProgressBar />
      </div>
    );
  }

  renderDropDown() {
    const {
      teams, disabled, indexedOwners, selectedTeam,
      auth,
    } = this.props;
    const { showMore } = this.state;
    const hasTeams = teams.length > 0;
    if (!hasTeams) {
      return <div>Please setup your team</div>;
    }
    
    const activeTeam = selectedTeam ? find(teams, { _id: selectedTeam._id }) || null : null;

    const members = activeTeam ? selectedTeam.members || [] : [];
    const total = members.length;
    const max = 5;
    const hasMore = total > max;
    const truncatedList = showMore ? members : slice(members, 0, max);
    const node = selectedTeam ? {
      ...selectedTeam,
      members: truncatedList,
    } : selectedTeam;
    const remaining = total - max;
    const activeTeamName = activeTeam !== null ?
      (
        <span>
          {truncate(activeTeam.name, { length: 30 })}{activeTeam.is_default && <span>&nbsp;<Fa name="star" className="text-warning" /></span>}
        </span>
      ) : (<span>Select a team</span>);

    if (teams.length === 1 && activeTeam) {
      return activeTeamName;
    }

 
    const menus = [];
    const globalTeams = [];
    const allOwners = [];

    each(teams, (team) => {
      const active = activeTeam && team._id === activeTeam._id;
      const isGlobal = team.is_global && team.user__id !== auth._id;

      const comp = (
        <MenuItem
          key={team._id}
          active={active}
          onSelect={() => { this.setTeam(team); }}
        >
          {truncate(team.name, { length: 30 })}{team.is_default && <span>&nbsp;<Fa name="star" className="text-warning" /></span>}
        </MenuItem>
      );
      if (team._id) {
        if (isGlobal) {
          globalTeams.push(comp);
        } else {
          menus.push(comp);
        }
      } else {
        allOwners.push(<MenuItem divider key="divider" />);
        allOwners.push(comp);
      }
    });

    const hasGlobal = globalTeams.length > 0;


    return (
      <div>
        <div style={{ position: 'relative', zIndex: 20 }}>
          <Dropdown
            disabled={disabled || teams.length === 1}
            id="dropdown-teams"
          >
            <Dropdown.Toggle bsSize="small">
              {activeTeamName}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {hasGlobal && <MenuItem header>My Teams:</MenuItem>}
              {menus}
              {hasGlobal && menus.length > 0 && <MenuItem divider />}
              {hasGlobal && <MenuItem header>Global Teams:</MenuItem>}
              {globalTeams}
              {allOwners}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {selectedTeam !== null && false &&
          <TeamMemberNode
            node={node}
            isRoot
            level={1}
            indexedOwners={indexedOwners}
          />
        }
        {(hasMore && false) &&
          <div style={{ paddingLeft: 66 }}>
            <a
              href=""
              onClick={this.showMore}
            >
              {showMore && <span>show less <Fa name="angle-double-up" /></span>}
              {!showMore && <span>show <NumberDisplay value={remaining} precision={0} /> more <Fa name="angle-double-down" /></span>}
            </a>
          </div>
        }
      </div>
    );
  }

  render() {
    const {
      canSeeTeamSeletor,
      loading, loaded,
      isRequired, hasTeamSetup,
    } = this.props;
    if (!canSeeTeamSeletor) {
      return null;
    }
    if (loading || !loaded) {
      return this.renderLoading();
    }
    const color = COLORS[1];

    const borderStyle = { borderColor: color, backgroundColor: tinycolor.mix(color, '#ffffff', 95).toHexString() };


    const showWarning = !hasTeamSetup && isRequired;

    if (!hasTeamSetup && !isRequired) {
      return null; // just hide it
    }

    return (
      <div className={`${styles.fieldGroup} ${styles.field} ${styles.fieldGroupRoot}`} style={{ marginBottom: '5px' }}>
        <div className={styles.fieldGroupBody}>
          <div className={styles.field} style={borderStyle}>
            {showWarning &&
              <div className="row" style={{ padding: '10px 25px' }}>
                <div className="text-danger">Please setup your team members first.</div>
              </div>
            }
            {!showWarning &&
              <FormGroup>
                <div className="row">
                  <div className="col-sm-4 col-md-3">
                    <div className="row">
                      <div className="col-sm-6">
                        <ControlLabel>Team</ControlLabel>
                      </div>
                      <div className="col-sm-6" style={{ paddingTop: 2 }}>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-8 col-md-9">
                    {this.renderDropDown()}
                  </div>
                </div>
              </FormGroup>
            }
          </div>
        </div>
      </div>
    );
  }
}

TeamSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  canSeeTeamSeletor: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  onTeamChange: PropTypes.func,
  selectedTeam: PropTypes.shape({}),
  teams: PropTypes.arrayOf(PropTypes.shape({})),
  indexedOwners: PropTypes.shape({}),
  isRequired: PropTypes.bool,
  hasTeamSetup: PropTypes.bool,
};
TeamSelector.defaultProps = {
  disabled: false,
  canSeeTeamSeletor: false,
  selectedTeam: null,
  onTeamChange: () => {},
  teams: [],
  loading: false,
  loaded: false,
  isRequired: false,
  hasTeamSetup: false,
  indexedOwners: PropTypes.shape({}),
};

function mapStateToProps(state, ownProps) {
  const auth = getUser(state);
  const organization = getUserCurrentOrganization(state);
  let canSeeTeamSeletor = false;
  if (auth) {
    if (auth.role === 'admin' || auth.role === 'superadmin') {
      canSeeTeamSeletor = true;
    } else if (auth.organization_role === 'admin' || auth.organization_role === 'manager') {
      canSeeTeamSeletor = true;
    } else if (auth.role === 'pi' && indexOf(auth.organization__ids, organization._id) >= 0) {
      canSeeTeamSeletor = true;
    }
  }
  let teams = getTeamTree(state);
  const hasTeamSetup = teams.length > 0;

  if (!ownProps.isRequired) {
    teams = [...teams, ALL_SALES_REPS];
  }
  return {
    auth,
    organization,
    canSeeTeamSeletor,
    hasTeamSetup,
    loading: getTeamTreeLoading(state),
    loaded: getTeamTreeLoaded(state),
    indexedOwners: getTeamTreeOwners(state),
    teams,
  };
}

export default connect(mapStateToProps)(TeamSelector);